import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPromotionsGrowth2024PopupTrialStartedComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('flow/promotions')
	declare flowPromotionsService: Service.Flow.Promotions;

	get promotion() {
		return this.flowPromotionsService.promotions.growthPlanDiscountOptionPromotion;
	}

	@action
	openGrowthPromoUpgradePopup() {
		this.flowPromotionsService.openGrowthPromoUpgradePopup('promote_growth_plan_popup');
	}
	<template>
		<div class="content">
			<img
				class="promo-image"
				src="/images/billing/promotions/growth-2024.png"
				alt="Upgrade promo"
			/>

			<h4>LIMITED OFFER</h4>

			<h3>
				Last days to save
				{{this.promotion.totalDiscountAmmountFormatted}}
				on Growth plan
			</h3>

			<p>
				Today is your last chance to save
				{{this.promotion.discountAmmountFormatted}}
				monthly in the first
				{{this.promotion.discountDurationInMonths}}
				months when you upgrade to the Growth plan.
			</p>

			<p>
				Upgrade now to keep access to advanced report slides, performance summaries, and
				more!
			</p>

			<p>
				Don’t miss out. Upgrade by
				{{this.promotion.formattedActiveUntilMMMDo}}
				and get
				{{this.promotion.totalDiscountAmmountFormatted}}
				off.
			</p>

			<div class="footer">
				<a
					role="button"
					class="button size-big"
					{{on "click" this.openGrowthPromoUpgradePopup}}
				>
					Upgrade now
				</a>
			</div>
		</div>
	</template>
}
